import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../entities/ExceptionEntity";
import BucketEntity from "../../entities/BucketEntity";
import BucketRepository from "../../repositories/BucketRepository";

interface props { bucketRepository: BucketRepository }

@injectable()
export default class GetAllBucketsUseCase {
    _bucketRepository: BucketRepository;

    constructor(_: props) {
        this._bucketRepository = _.bucketRepository;
    }

    public call = async (): Promise<Either<ExceptionEntity, BucketEntity[]>> => {
        return await this._bucketRepository.getAll();
    }
}

export const GetAllBucketsUseCaseName = "GetAllBucketsUseCaseName";
